import React from 'react' 
import { FaMedium, FaGithub, FaLinkedin } from 'react-icons/fa';

const SocialMedia = () => {
  return (
    <div className='app__social'>
      <a href='https://www.linkedin.com/in/elisabethjoyashley' target='_blank' rel='noopener noreferrer'>
        <div>
          <FaLinkedin />
        </div>
      </a>
      <a href='https://medium.com/@elisabethashley' target='_blank' rel='noopener noreferrer'>
        <div>
          <FaMedium />
        </div>
      </a>
      <a href='https://github.com/eashl003' target='_blank' rel='noopener noreferrer'>
        <div>
          <FaGithub />
        </div>
      </a>
    </div>
  )
}

export default SocialMedia